import React, { createContext, memo, useContext, useRef, useState } from "react";

export const WMSContext = createContext({
  reloadPageData: false,
  setReloadPageData: () => {},
  filterData: {},
  setFilterData: () => {},
  helpLink: "",
  setHelpLink: () => {},
  ssbHistorySectionData: true,
  setSsbHistorySectionData: () => {},
  jscdChangelogComponentRef: null,
  spreadyContext: {},
  setSpreadyContext: () => {},
});

export const useWMSContext = () => useContext(WMSContext);

/**
 * Provides a context for managing the 404 error state
 * and any states to be used in the future
 *
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The child components.
 * @returns {ReactNode} The context provider component.
 */
export const WMSContextProvider = memo(({ children }) => {
  const [ssbHistorySectionDataC, setSsbHistorySectionDataC] = useState(true);
  const jscdChangelogComponentRef = useRef();

  const [reloadPageDataC, setReloadPageDataC] = useState(false);
  const [filterDataC, setFilterDataC] = useState({});
  const [helpLinkC, sethelpLinkC] = useState("");

  const [spreadyContext, setSpreadyContext] = useState({});

  return (
    <WMSContext
      value={{
        reloadPageData: reloadPageDataC,
        setReloadPageData: setReloadPageDataC,
        filterData: filterDataC,
        setFilterData: setFilterDataC,
        helpLink: helpLinkC,
        setHelpLink: sethelpLinkC,
        ssbHistorySectionData: ssbHistorySectionDataC,
        setSsbHistorySectionData: setSsbHistorySectionDataC,
        jscdChangelogComponentRef: jscdChangelogComponentRef,
        spreadyContext: spreadyContext,
        setSpreadyContext: setSpreadyContext,
      }}
    >
      {children}
    </WMSContext>
  );
});
